import PropTypes from 'prop-types';

import { DashboardLayout } from '../../layouts';
import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { CircularProgress } from '@classity-edtech/ui-base';
import { Roles } from '@classity-edtech/platform-utils';
import { Stack, Typography } from '@mui/material';
import Helmet from '../../components/Helmet';
import PendingState from '../../components/PendingState';
import { useGetMyProfileQuery } from '../../services/users';

export interface DashboardProps extends MuiBoxProps {}

export const Dashboard = ({ className }: DashboardProps) => {
  const { data: user, isLoading: loadingUser, isFetching: fetchingUser } = useGetMyProfileQuery();

  const navigate = useNavigate();

  useEffect(() => {
    if (user && user?.roleId !== Roles.STUDENT) {
      navigate(`/404`, { replace: true });
    }
  }, [user]);

  return (
    <>
      <Helmet />
      <DashboardLayout>
        {loadingUser || fetchingUser ? (
          <Box
            sx={{
              width: '100%',
              height: '80vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Stack sx={{ gap: 3 }}>
            <Typography variant='subtitle3'>
              Welcome back,&nbsp;{user?.profile?.firstname}
            </Typography>

            <PendingState />
          </Stack>
        )}
      </DashboardLayout>
    </>
  );
};

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Dashboard.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(Dashboard)(
  ({ theme }) => `
`,
);
